/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import {
    AfterViewInit,
    Component,
    OnInit,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';
import * as globalL10n from 'global-l10n';

import {
    IAviDataGridConfig,
} from 'ng/modules/data-grid/components/avi-data-grid/avi-data-grid.types';

import * as l10n from './log-cinematic-sub-section-saml.l10n';
import { TrafficLogCinematicStore } from '../../../traffic-logs/traffic-log-cinematic/traffic-log-cinematic.store';

import './log-cinematic-sub-section-saml.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;
const { ...globalL10nKeys } = globalL10n;

/**
 * @description
 *     Component for displaying the SAML sub-section in the Authentication section under traffic Log cinematic view.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'log-cinematic-sub-section-saml',
    templateUrl: './log-cinematic-sub-section-saml.component.html',
})
export class LogCinematicSubSectionSamlComponent implements OnInit, AfterViewInit {
    /**
     * Datagrid template for the SAML attribute name field.
     */
    @ViewChild('samlAttributeNameFieldTemplateRef')
    public readonly samlAttributeNameFieldTemplateRef: TemplateRef<HTMLElement>;

    /**
     * Datagrid template for the SAML attribute values field.
     */
    @ViewChild('samlAttributeValuesFieldTemplateRef')
    public readonly samlAttributeValuesFieldTemplateRef: TemplateRef<HTMLElement>;

    public readonly samlLog$ = this.logCinematicStore.samlLog$;

    public readonly globalL10nKeys = globalL10nKeys;

    public readonly l10nKeys = l10nKeys;

    public samlAttributeListGridConfig: IAviDataGridConfig;

    constructor(
        public readonly logCinematicStore: TrafficLogCinematicStore,
        private readonly l10nService: L10nService,
    ) {
        this.l10nService.registerSourceBundles(dictionary);
    }

    /** @override */
    public ngOnInit(): void {
        this.samlAttributeListGridConfig = {
            fields: [],
            layout: {
                hideCheckboxes: true,
            },
        };
    }

    /** @override */
    public ngAfterViewInit(): void {
        this.samlAttributeListGridConfig.fields = [
            {
                label: this.l10nService.getMessage(l10nKeys.attributeNameLabel),
                id: 'attribute-name',
                templateRef: this.samlAttributeNameFieldTemplateRef,
            },
            {
                label: this.l10nService.getMessage(l10nKeys.attributeValuesLabel),
                id: 'attribute-values',
                templateRef: this.samlAttributeValuesFieldTemplateRef,
            },
        ];
    }
}
